// extracted by mini-css-extract-plugin
module.exports = {"root":"mz5EOGBfu_NcXY9cQ7PA","value":"zsUi1KAhgobvFXWBrHuc"};